import { initialState } from '../initialState';
import {
  APPROVAL_MODAL,
  EDIT_POST_MODAL,
  INTERESTS_MODAL,
  MY_POSTS,
  MY_COMMENT,
  USER_INFO,
  POST_LIKES_MODAL
} from './constants';

const generalReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_INFO:
      return {
        ...state,
        userInfo:{...action.payload}
      }
    // posts
    case MY_POSTS:
      return {
        ...state,
        myPosts: [...action.payload]
      };
    // Modals
    case APPROVAL_MODAL:
      return {
        ...state,
        approvalModal: {
          open: action.payload.open,
          detail: action.payload.detail
        }
      };
    case EDIT_POST_MODAL:
      return {
        ...state,
        editPostModal: {
          open: action.payload.open,
          detail: action.payload.detail
        }
      };
    case INTERESTS_MODAL:
      return {
        ...state,
        interestsModal: {
          open: action.payload.open,
          detail: action.payload.detail,
          isFirstLogin: action.payload.isFirstLogin
        }
      };

    case POST_LIKES_MODAL:
      return {
        ...state,
        postLikesModal:{
          open:action.payload.open,
          isPostLike:action.payload.isPostLike,
          id:action.payload.id,
          commentId:action.payload.commentId
        }
      }

    case MY_COMMENT:
      return {
        ...state,
        myComment: [...action.payload]
      };
    default:
      return state;
  }
};

export { initialState, generalReducer };
